/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Credential_Not_RecoverableInputs */

const es_co2_error_credential_not_recoverable = /** @type {(inputs: Error_Credential_Not_RecoverableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta llave no se puede recuperar; solicita una nueva.`)
};

/**

* @param {Error_Credential_Not_RecoverableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_credential_not_recoverable = /** @type {((inputs?: Error_Credential_Not_RecoverableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Credential_Not_RecoverableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_credential_not_recoverable(inputs)
});